
import { mdiChevronRight } from '@mdi/js'
export default {
  name: 'FeatureCardComponent',
  props: {
    entity: {
      type: Object,
      default: null,
    },
  },
  data: () => {
    return {
      mdiChevronRight,
    }
  },
  computed: {
    cardAttrs() {
      if (!this.url) return { to: '/' }
      return { to: this.url }
    },
    url() {
      if (!this.entity?.slug) return
      return `/feature/${this.entity.slug}`
    },
  },
}
